<div class="content_card" [class]="ClassList ? ClassList : ''">
    <ng-content select="*"></ng-content>
</div>